const fonts = [
    {
      family: 'STC_Mistral',
      url: '/wp-content/plugins/octo-stc/public/assets/signature/MISTRAL.woff2'
    },
    {
      family: 'STC_ArialMS',
      url: '/wp-content/plugins/octo-stc/public/assets/signature/ArialMS.woff2'
    },
    {
      family: 'STC_Birthstone',
      url: '/wp-content/plugins/octo-stc/public/assets/signature/Birthstone.woff2'
    },
    {
      family: 'STC_Rage',
      url: '/wp-content/plugins/octo-stc/public/assets/signature/Rage.woff2'
    },
    {
      family: 'STC_Ballet',
      url: '/wp-content/plugins/octo-stc/public/assets/signature/Ballet.woff2'
    },
    {
      family: 'AgencyFB-Bold',
      url: '/wp-content/plugins/octo-stc/public/assets/fonts/AgencyFB-Bold.woff2'
    },
    {
      family: 'AgencyFB-Reg',
      url: '/wp-content/plugins/octo-stc/public/assets/fonts/AgencyFB-Reg.woff2'
    },
    {
      family: 'Anton',
      url: '/wp-content/plugins/octo-stc/public/assets/fonts/Anton.woff2'
    },
    {
      family: 'ArchivoNarrow-Regular',
      url: '/wp-content/plugins/octo-stc/public/assets/fonts/ArchivoNarrow-Regular.woff2'
    },
    {
      family: 'EdwardianScriptITC',
      url: '/wp-content/plugins/octo-stc/public/assets/fonts/EdwardianScriptITC.woff2'
    },
    {
      family: 'Freshman',
      url: '/wp-content/plugins/octo-stc/public/assets/fonts/Freshman.woff2'
    },
    {
      family: 'GOODBRUSH',
      url: '/wp-content/plugins/octo-stc/public/assets/fonts/GOODBRUSH.woff2'
    },
    {
      family: 'Impact',
      url: '/wp-content/plugins/octo-stc/public/assets/fonts/Impact.woff2'
    },
    {
      family: 'KristenITC-Regular',
      url: '/wp-content/plugins/octo-stc/public/assets/fonts/KristenITC-Regular.woff2'
    },
    {
      family: 'MyriadPro-BoldCondIt',
      url: '/wp-content/plugins/octo-stc/public/assets/fonts/MyriadPro-BoldCondIt.woff2'
    },
    {
      family: 'MyriadPro-Regular',
      url: '/wp-content/plugins/octo-stc/public/assets/fonts/MyriadPro-Regular.woff2'
    },
    {
      family: 'OrdinaryGuyDEMO',
      url: '/wp-content/plugins/octo-stc/public/assets/fonts/OrdinaryGuyDEMO.woff2'
    },
    {
      family: 'OswaldStencil-Bold',
      url: '/wp-content/plugins/octo-stc/public/assets/fonts/OswaldStencil-Bold.woff2'
    },
    {
        family: 'birds_of_paradise',
        url: '/wp-content/plugins/octo-stc/public/assets/fonts/birds_of_paradise.woff2'
    }
];
  
  // Function to load a single font
  async function loadFont(fontFamily, fontUrl) {
    try {
      // Create a new FontFace object
      const font = new FontFace(fontFamily, `url(${fontUrl})`, {
        style: 'normal',
        weight: 'normal',
        display: 'swap' // This can be 'auto', 'block', 'swap', 'fallback', or 'optional'
      });
      
      // Wait for the font to load
      const loadedFont = await font.load();
      
      // Add the loaded font to the document fonts
      document.fonts.add(loadedFont);
      
    //   console.log(`Font ${fontFamily} loaded successfully!`);
      return loadedFont;
    } catch (error) {
      console.error(`Failed to load font ${fontFamily}:`, error);
      throw error;
    }
  }
  
  // Function to load all fonts
  async function loadAllFonts() {
    try {
      // Create an array of promises for loading each font
      const fontPromises = fonts.map(font => loadFont(font.family, font.url));
      
      // Wait for all fonts to load
      const loadedFonts = await Promise.all(fontPromises);
      
    //   console.log('All fonts loaded successfully!');
      return loadedFonts;
    } catch (error) {
      console.error('Error loading fonts:', error);
      throw error;
    }
  }
  
  // Function to check if document.fonts is ready (loaded)
  function areFontsReady() {
    return document.fonts.ready.then(() => {
      console.log('All fonts are ready for use!');
      return true;
    });
  }
  
// Export functions in case you need to use them elsewhere
export { loadFont, loadAllFonts, areFontsReady };